module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/180xaPN/tc-custom/9781528993838.jpg?1728724785526",
      "alt": "This image is the cover for the book The Meeting of the Feeling"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Meeting of the Feeling\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The handsome Ben Thomas is one of four deputies to the Director of Education in a town hall in the south of England. His main interests are his feud with Andy Patfoul, an Inspector; his pursuit of Linda Foxton, his would-be girlfriend; and his love of intrigue. This leads him into the clutches of a powerful politician who wants Ben to take part in an ambitious scheme to renovate the city. He also becomes involved with a devious priest. He humiliates the headteacher in an interview and his wife suspects his affair with Lindy. He appoints a useless candidate to Andy’s team. His father-in-law evicts him from his home. His enemies are meeting each other. Ben needs a miracle!")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John E. Patten\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("John E. Patten was born in the Docklands area of South London in 1940. A potential literary career could have ended when Hitler bombed the Hospital. His schooling took place in the East End and Boys Brigade Camps gave him a taste of life outside the capital. John was the first of his family to go onto higher education at Bishop Otter College, Chichester. He taught primary schools in West Sussex, Hampshire, Essex and North Yorkshire and became a head teacher in Cheshire for 24 years before retirement. John is married to a retired teacher and has one daughter who declined any suggestion of entering the profession.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0